(ns frontend.ui.component.select-input.style
  (:require
   [frontend.ui.style.theme.core :refer [color text-size]]
   [frontend.ui.style.theme.core :as theme]
   [garden.util :refer [space-join]]))

;; See https://react-select.com/styles

(def custom-styles
  (clj->js
   {:clearIndicator
    (fn [_provided _state]
      #js {})
    :container
    (fn [_provided _state]
      #js
              {"backgroundColor" (theme/color [:select-input :container :bg])
               "border"          (space-join ["1px" "solid"
                                              (theme/color [:select-input :container :border])])
               "borderRadius"    "4px"
               "position"        "relative"})
    :control
    (fn [_provided _state]
      #js
              {"minHeight"      "46px"
               "padding"        "8px 12px"
               "display"        "flex"
               "alignItems"     "center"
               "justifyContent" "space-between"
               "fontSize"       (text-size :small :size)})
    :dropdownIndicator
    (fn [_provided _state]
      #js {"paddingLeft" "6px"})
    :group
    (fn [_provided _state]
      #js {"padding" "12px"})
    :groupHeading
    (fn [_provided _state]
      #js {"backgroundColor" (theme/color [:select-input :group-heading :bg])})
    :indicatorsContainer
    (fn [_provided _state]
      #js {"display" "flex"})
    :indicatorSeparator
    (fn [_provided _state]
      #js {"backgroundColor" (theme/color [:select-input :indicator-separator])})
    :input
    (fn [_provided _state]
      #js
              {"display"    "flex"
               "alignItems" "center"})
    :loadingIndicator
    (fn [_provided _state]
      #js {"backgroundColor" (theme/color [:select-input :loading-indicator])})
    :loadingMessage
    (fn [_provided _state]
      #js {"backgroundColor" (theme/color [:select-input :loading-message])})
    :menu
    (fn [_provided _state]
      #js
              {"backgroundColor" (theme/color [:select-input :menu])
               "position"        "fixed"
               "width"           "inherit"
               "z-index"         "20"
               "border"          (space-join ["1px" "solid"
                                              (theme/color [:select-input :container :border])])})
    :menuList
    (fn [_provided _state]
      #js
              {"maxHeight" "300px"
               "overflow"  "auto"})
    :menuPortal
    (fn [_provided _state]
      _provided)
    :multiValue
    (fn [_provided _state]
      #js
              {"display"      "flex"
               "text-wrap"    "nowrap"
               "alignItems"   "center"
               "padding"      "4px"
               "margin"       "2px 6px 2px 0"
               "border"       (space-join ["1px" "solid"
                                           (theme/color [:select-input :multi-value :border])])
               "color"        (theme/color [:select-input :multi-value :fg])
               "borderRadius" "3px"})
    :multiValueLabel
    (fn [_provided _state]
      #js {"fontSize" (text-size :xxsmall :size)})
    :multiValueRemove
    (fn [_provided _state]
      #js
              {"display"    "flex"
               "alignItems" "center"
               "padding"    "0 0 0 4px"
               "cursor"     "pointer"})
    :noOptionsMessage
    (fn [_provided _state]
      #js
              {"padding" "12px"})
    :option
    (fn [_provided state]
      (cond
        ^boolean (.-isSelected state)
        #js
                {"padding"         "12px"
                 "whitespace"      "nowrap"
                 "borderTop"       (space-join ["1px" "solid"
                                                (theme/color [:select-input :option :selected
                                                              :border-top])])
                 "backgroundColor" (theme/color [:select-input :option :selected :bg])
                 "color"           (theme/color [:select-input :option :selected :fg])}
        ^boolean (.-isFocused state)
        #js
                {"padding"         "12px"
                 "borderTop"       (space-join ["1px" "solid"
                                                (theme/color [:select-input :option :focused
                                                              :border-top])])
                 "backgroundColor" (theme/color [:select-input :option :focused :bg])
                 "color"           (theme/color [:select-input :option :focused :fg])}
        :else
        #js
                {"padding"   "12px"
                 "borderTop" (space-join ["1px" "solid"
                                          (theme/color [:select-input :option :border-top])])}))
    :placeholder
    (fn [_provided _state]
      #js
              {"display"   "flex"
               "position"  "static"
               "transform" "none"
               "color"     (theme/color [:select-input :placeholder :fg])})
    :singleValue
    (fn [_provided _state]
      #js
              {"fontSize"   (text-size :small :size)
               "position"   "static"
               "transform"  "none"
               "whiteSpace" "nowrap"})
    :valueContainer
    (fn [_provided _state]
      #js
              {"display"  "flex"
               "flexWrap" "wrap"})}))
